export default __webpack_public_path__ + "static/sk-bbfbceb33bf561fb6ad2e9d736cc6502.svg";